import { useNotifications } from '../contexts/NotificationContext';

export const useToast = () => {
    let addNotification, removeNotification;

    try {
        const notifications = useNotifications();
        addNotification = notifications.addNotification;
        removeNotification = notifications.removeNotification;
    } catch (error) {
        // Fallback se il context non è disponibile
        addNotification = (message, type, duration) => {
            if (window.addNotification) {
                window.addNotification(message, type, duration);
            } else {
                console.warn('Notification system not available:', message);
            }
        };
        removeNotification = () => {};
    }

    const showSuccess = (message, duration = 3000) => {
        addNotification(message, 'success', duration);
    };

    const showError = (message, duration = 3000) => {
        addNotification(message, 'error', duration);
    };

    const showInfo = (message, duration = 3000) => {
        addNotification(message, 'info', duration);
    };

    return { 
        showSuccess, 
        showError, 
        showInfo,
        removeNotification 
    };
};